export const environment = {
  production: true,
  buildId: '3364574467521901',
  configFile: 'config.json',
};
